export default __webpack_public_path__ + "static/trustify-header-23126f96808bd0e6a86460ef0188ae54.jpg";